import { createFileRoute } from "@tanstack/react-router";
import { Bell, BellOff } from "lucide-react";

import { Button } from "@/components/ui/button";

import { usePushNotifications } from "../../../notifications/use-push";

export const Route = createFileRoute("/_workspace/settings/notifications")({
  component: NotificationsPane,
});

/**
 * Per-DEVICE notification opt-in. A push subscription belongs to one browser on
 * one device, so this pane reports the state of the device you're reading it
 * on — turning it on here doesn't turn it on for your phone.
 */
function NotificationsPane() {
  const push = usePushNotifications();

  return (
    <div className="mx-auto w-full max-w-2xl px-6 pt-8 pb-12">
      <h1 className="text-lg font-semibold">Notifications</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Get notified on this device when Heath needs your approval to do
        something.
      </p>

      <section className="mt-6">
        {push.status === "unavailable" ? (
          <p className="text-sm text-muted-foreground">
            Notifications aren't available in this browser.
          </p>
        ) : push.status === "blocked" ? (
          <p className="text-sm text-muted-foreground">
            Notifications are blocked for this site. Re-allow them in your
            browser's site settings, then come back.
          </p>
        ) : push.status === "on" ? (
          <div className="flex flex-col items-start gap-3">
            <p className="text-sm text-foreground">
              Notifications are on for this device.
            </p>
            <Button
              variant="outline"
              disabled={push.pending}
              onClick={() => push.disable()}
            >
              <BellOff className="mr-2 h-4 w-4" />
              Turn off
            </Button>
          </div>
        ) : (
          <Button disabled={push.pending} onClick={() => push.enable()}>
            <Bell className="mr-2 h-4 w-4" />
            Turn on notifications
          </Button>
        )}
        {push.error ? (
          <p className="mt-3 text-sm text-destructive">
            {(push.error as Error).message}
          </p>
        ) : null}
      </section>
    </div>
  );
}
